
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy-universities",
      function () {
        return require("private-next-pages/privacy-policy-universities/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy-policy-universities"])
      });
    }
  